import "./assets/public_shell.scss";

import { bootstrapLocalDebugOverlays } from "@/helpers/debug/bootstrapLocalDebugOverlays";
import { initLegacyFlowbiteGlobals } from "@/helpers/legacy/initLegacyFlowbiteGlobals";
import { createSsrHydrationToggle, shouldHydrateSSRIslands } from "@/helpers/ssrHydrationToggle";
import { registerOfflineMirrorSw } from "@/helpers/registerOfflineMirrorSw";

bootstrapLocalDebugOverlays();
initLegacyFlowbiteGlobals();
registerOfflineMirrorSw();

createSsrHydrationToggle();

if (shouldHydrateSSRIslands() && document.querySelector("[data-vue-ssr-component]")) {
  import("./hydrate-ssr").then(({ hydrateSSRIslands }) => {
    hydrateSSRIslands();
  });
}
